import { TFunction } from "i18next";
import {
  MaterialStockItem,
  PackagingItem,
  ReportItem,
  ReportType,
} from "shared/api";

export const reportTypes: Record<ReportType, string> = {
  [ReportType.MATERIAL_ITEM]: "Material Item",
  [ReportType.PACKAGING]: "Packaging",
  [ReportType.REEL_LAB_ARCHIVE]: "Reel Lab Archive",
  [ReportType.ORDER]: "Order",
  [ReportType.MULTIPLE_ORDER]: "Multiple Order",
  [ReportType.MULTIPLE_PACKAGING]: "Multiple Packaging",
  [ReportType.MULTIPLE_ORDER_PACKAGING]: "Multiple Order Packaging",
  [ReportType.MULTIPLE_MATERIAL]: "Multiple Material",
  [ReportType.MULTIPLE_QUALITY]: "Multiple Quality",
  [ReportType.MULTIPLE_MATERIAL_ITEM]: "Multiple Material Item",
  [ReportType.MANAGEMENT]: "Managment",
  [ReportType.DRIGGING_RIGG]: "Drigging Rigg",
  [ReportType.STOCK]: "Stock",
};

export const renderReportType = (report: ReportItem) => {
  const status = reportTypes[report?.report_type as ReportType];
  return status || "Unknown Type";
};

export const renderIsDefaultString = (report: ReportItem) => {
  return report?.is_default ? "Default" : "Not Default";
};

const normalizeNameToCode = (name: string) =>
  name
    .toUpperCase()
    .replace(/\s*-\s*/g, "_")
    .replace(/\s+/g, "_");

export const renderReportTypeTitle = (reportType: string, t: TFunction) =>
  t(`reportTypes.${reportType}`, {
    defaultValue: reportType
      .replaceAll("_", " ")
      .toLowerCase()
      .replace(/^\w/, (c) => c.toUpperCase()),
  });

export const renderReportTitle = (report: ReportItem, t: TFunction) => {
  const code = normalizeNameToCode(report.name);

  return t(`reportsByCode.${code}`, {
    defaultValue: report.name,
  });
};

export const getPackagingDataFromMateriaStockItem = (
  materialStockItem: MaterialStockItem
) => {
  const materialPackagingData = materialStockItem?.packaging as PackagingItem;
  const packagingMaterialId =
    materialPackagingData?.material as unknown as number;

  return {
    id: materialPackagingData?.id,
    name: materialPackagingData?.name,
    material: packagingMaterialId,
    order: materialPackagingData?.order,
  };
};
